<div class="h-screen flex flex-col justify-center items-center">
    <div class="text-center font-bold text-lg">reGenesis</div>
    <div class="text-center text-md">Scan products to view the details</div>

    <!-- QR Detection Timeout Dialog -->
    <p-dialog [visible]="showTimeoutDialog()" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
        [style]="{ width: '90vw', maxWidth: '400px' }" [contentStyle]="{ padding: '2rem', textAlign: 'center' }"
        [header]="''">

        <!-- Error Icon using PrimeNG Avatar -->
        <p-avatar icon="pi pi-exclamation-circle" size="xlarge" styleClass="timeout-modal-icon mb-6" shape="circle">
        </p-avatar>

        <!-- Title -->
        <h2 class="timeout-modal-title text-xl font-bold mb-4">No QR Code Detected</h2>

        <!-- Description -->
        <p class="timeout-modal-description mb-6 text-sm leading-relaxed text-gray-600">
            We couldn't detect a QR code in the camera preview. Please make sure the QR code is clearly visible and try
            again.
        </p>

        <!-- Instructions box -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
            <p class="text-xs text-blue-800 leading-relaxed mb-3">
                <strong>Tips for successful scanning:</strong>
            </p>
            <ul class="text-xs text-blue-800 leading-relaxed list-disc list-inside space-y-2">
                <li>Ensure there is enough light</li>
                <li>Hold the device steady</li>
                <li>Place the QR code inside the central frame</li>
                <li>Avoid reflections on the surface</li>
            </ul>
        </div>

        <!-- Buttons -->
        <div class="timeout-buttons-container">
            <p-button label="Ok" severity="primary" size="large" styleClass="w-full" (onClick)="closeTimeoutDialog()">
            </p-button>
        </div>
    </p-dialog>
</div>